import { render } from "./BibliotecasSection.vue?vue&type=template&id=ad61bf42&scoped=true"
import script from "./BibliotecasSection.vue?vue&type=script&lang=js"
export * from "./BibliotecasSection.vue?vue&type=script&lang=js"

import "./BibliotecasSection.vue?vue&type=style&index=0&id=ad61bf42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad61bf42"]])

export default __exports__